import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AnimatedLeafyBackground from "./components/AnimatedLeafyBackground";
import FloatingContactWidget from "./components/FloatingContactWidget";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import RoomDetail from "./pages/RoomDetail";
import Restaurant from "./pages/Restaurant";
import Conference from "./pages/Conference";
import EventsActivities from "./pages/EventsActivities";
import Contact from "./pages/Contact";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
// If you plan to add later:
// import Privacy from "./pages/Privacy";
// import Terms from "./pages/Terms";
// import Faq from "./pages/Faq";

function App() {
    return (
        <div className="min-h-screen bg-backgroundLight relative">
            {/* Animated Leafy Background */}
            <AnimatedLeafyBackground />

            {/* Left Margin Decoration */}
            {/* <MarginDecoration side="left" /> */}

            {/* Right Margin Decoration */}
            {/* <MarginDecoration side="right" /> */}
            
            <Router>
                <div className="relative z-10">
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/rooms" element={<Rooms />} />
                        <Route path="/rooms/:roomSlug" element={<RoomDetail />} />
                        <Route path="/restaurant" element={<Restaurant />} />
                        <Route path="/conference" element={<Conference />} />
                        <Route path="/events" element={<EventsActivities />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/about" element={<About />} />
                        {/* You can add these routes later */}
                        {/* <Route path="/privacy-policy" element={<Privacy />} /> */}
                        {/* <Route path="/terms" element={<Terms />} /> */}
                        {/* <Route path="/faq" element={<Faq />} /> */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    <Footer />
                    
                    {/* Floating Contact Widget */}
                    <FloatingContactWidget />
                </div>
            </Router>
        </div>
    );
}

export default App;